<template>
    <div class="folder-card card-box">
        <div class="folder-card-avatar">
            <img src="@/assets/images/icon/folder.png">
        </div>
        <div class="folder-card-caption">
            <input class="folder-card-caption-edit" ref="editName" v-show="isEdit" :value="item.fileName" type="text"
                @blur="saveFileName" @click.stop>
            <strong class="folder-card-caption-text" v-show="!isEdit" :title="item.fileName">{{ item.fileName
                }}</strong>
        </div>
        <div class="folder-card-toolbar">

            <span class="folder-card-toolbar-btn icon-glyphicon-option-horizontal"
                @click.stop="folderCardMenuShow = !folderCardMenuShow"></span>

            <ul class="map-drop-down-list" v-show="folderCardMenuShow">
                <li class="map-drop-down-list-item" @click.stop="visible = true, folderCardMenuShow = false">详情</li>
                <li class="map-drop-down-list-item" @click.stop="isEdit = !isEdit, folderCardMenuShow = false">重命名</li>
                <li class="map-drop-down-list-item" @click.stop="openFolderSelect(), folderCardMenuShow = false">移动</li>
                <li class="map-drop-down-list-item" @click.stop>成员管理</li>
                <li class="map-drop-down-list-item" @click.stop="delFolder(), folderCardMenuShow = false">删除</li>
            </ul>
        </div>
        <el-dialog v-model="visible" :show-close="false" width="500" @click.stop>
            <template #header="{ close, titleId, titleClass }">
                <div class="folder-info-header">
                    <h4 :id="titleId" :class="titleClass">详情</h4>
                    <div class="folder-info-close" @click.stop="close">×</div>
                </div>
            </template>
            <div class="folder-info-context">
                <p>名称：{{ item.fileName }}</p>
                <p>创建人：{{ item.createByName }}</p>

                <p>创建时间：{{ item.createTime }}</p>
                <p>修改人：{{ item.updateUserId }}</p>
                <p>修改时间：{{ item.updateTime }}</p>

                <p>协作人数：{{ item.number }}</p>
                <p>类型：{{ item.type }}</p>

            </div>
        </el-dialog>
        <FolderSelect ref="folderSelect" @confirm="handleMoveFolder" />
    </div>

</template>

<script>
import { delFolder, updateFolder } from '@/api/Common';
import { useRouter, useRoute } from 'vue-router';
import FolderSelect from './FolderSelect.vue';

export default {
    name: 'FolderCard',
    components: {
        FolderSelect
    },
    data() {
        return {
            folderCardMenuShow: false,
            isEdit: false,
            visible: false,
            router: null
        }
    },
    props: {
        item: {
            type: Object, // 假设 item 是对象类型，根据实际情况调整
            required: true // 表示该参数是必需的
        }
    },
    mounted() {
        this.router = useRouter();

    },
    methods: {
        openFolderSelect() {
            this.$refs.folderSelect.open();
        },
        handleMoveFolder(selectedFolder) {

            let that = this;
            updateFolder({ "id": this.item.id, "pid": selectedFolder.id }).then(res => {
                if (res.code === 200) {
                    that.$emit('map-refresh');
                }
            })
        },
        delFolder() {
            let that = this;
            delFolder({ "id": this.item.id }).then(res => {
                if (res.code == 200) {
                    that.$emit('map-refresh');
                }
            })
        },
        saveFileName() {
            this.isEdit = false;
            let newFileName = this.$refs.editName.value;
            this.item.fileName = newFileName;
            let that = this;
            updateFolder({ "id": this.item.id, "fileName": newFileName }).then(res => {

            })
        }

    }
}

</script>

<style scoped>
.el-dialog {
    padding: 0px !important;
}

.folder-info-close {
    color: #fff;
    font-size: 26px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
}

.folder-info-header {
    position: relative;
    height: 46px;
    padding:
        12px;
    background-color: #1b2d3e;
    color: #fff;
    border-radius:
        5px 5px 0 0;

}

.folder-info-header h4 {
    color: #fff;
}

.folder-info-context {
    padding: 10px;
}



.folder-card {
    position: relative;
    box-shadow: 0px 1px 6px 2px rgba(0, 0, 0, 0.15);
    border: 1px solid #e6e9eb;
    cursor: pointer;
    color: #333333;
}




.folder-card-avatar {
    display: flex;
    justify-content: center;
    margin-top: 40px;

}

.folder-card-avatar img {
    width: 50%;
    height: 50%;
    vertical-align: middle;
}

.folder-card-caption {
    position: absolute;
    height: 36px;
    width: 100%;
    background-color: rgba(229, 229, 234, 0.9);
    overflow: hidden;
    bottom: 0;
    transition: height 0.2s;
    z-index: 1;
    text-align: center;
    line-height: 36px;
}

.folder-card-caption-edit {
    height: 36px;
    width: 100%;
    font-size: 14px;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;
    border-radius: 4px;
    padding: 6px 12px;
}

.folder-card-caption-edit:focus {
    border-color: #66afe9;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);

}

.folder-card-caption-text {}

.folder-card-toolbar {
    position: absolute;
    right: 8px;
    top: 6px;
}

.folder-card-toolbar-btn {
    font-size: 14px;
    padding: 8px 6px;
    color: #666;
}






@media screen and (min-width: 1680px) {
    .folder-card-caption {
        height: 40px;
        line-height: 40px;
    }

}

@media screen and (min-width: 1920px) {
    .folder-card-caption {
        height: 40px;
        line-height: 40px;
    }

}
</style>